module.exports = __webpack_public_path__ + "static/nick-signature-1a130fa3b4b5630915be6e63cc1335b3.jpg";